<template>
<v-container fluid>
<v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="-1"
  absolute
  >
  {{ message }}
  <v-btn
    dark
    text
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
 </v-snackbar>
  <v-layout class="mt-12">
  <v-flex xs12>
    <div :class="paginatedLimits.length === 7 ? 'viewlimits_box' : 'viewlimits_box_empty'">
      <v-card-text>
    <v-layout>
      <v-flex xs3>
      <span class="accent--text" style="font-size: 14px; font-weight:700;"> Limits</span>
    </v-flex>
    <v-spacer>
    </v-spacer>
    <v-flex xs3>
       <v-text-field label="Search" v-model="search">
       </v-text-field>
     </v-flex>
     </v-layout>
      <table class="table">
         <thead class="thead">
          <tr>
            <th scope="col">Name</th>
            <th scope="col">ID Number</th>
            <th scope="col">Mobile Number</th>
            <th scope="col">Previous Limit(KES)</th>
            <th scope="col">Current Limit(KES)</th>
            <th scope="col">Rate(Per KG)</th>
            <th scope="col">Latest Weight(KG)</th>
            <th scope="col">Season</th>
            <th scope="col">Approved By</th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="limit in filteredList" v-bind:key="limit.id">
          <td> {{ limit.name }} </td>
          <td> {{ limit.idNumber }} </td>
          <td> {{ limit.mobileNumber }} </td>
          <td> {{ limit.prevLimit }} </td>
          <td> {{ limit.currLimit }} </td>
          <td> {{ limit.rate }} </td>
          <td> {{ limit.delivery }} </td>
          <td> {{ limit.season }}</td>
          <td> {{ limit.approvedBy }}</td>
        </tr>
        </tbody>
      </table>
      </v-card-text>
      <v-card-actions>
        <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
        <v-spacer></v-spacer>
        <v-pagination
        v-model="page"
        :length="numberOfLinks"
        color="secondary"
                class="accent--text logoutbtn"
      ></v-pagination>
      </v-card-actions>
    </div>
  </v-flex>
  </v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'

export default {
	name: 'viewlimits',
	data: function () {
		return {
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			limits: [],
			totalLimits: 0,
			pagination: { sortBy: 'id', descending: true },
			search: '',
			paginatedLimits: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			organisationType: '',
			organisationId: ''
		}
	},
	mounted () {
		this.getLoggedInUser()
		this.getLimits()
	},
	watch: {
		limits () {
			this.paginatedLimits = this.paginationMethod(this.limits, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.limits.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedLimits = this.paginationMethod(this.limits, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedLimits
			} else {
				return this.limits.filter(limit => {
					console.log(limit)
					return limit.farmer !== null && limit.farmer.fullName !== null && (limit.farmer.fullName.toLowerCase().includes(this.search.toLowerCase()) || limit.farmer.farmerId.includes(this.search.toLowerCase()) || limit.farmer.mobileNumber.includes(this.search.toLowerCase()))
				})
			}
		}
	},
	methods: {
		getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
			this.organisationType = this.theUser.organisation.organisationType.name
			this.organisationId = this.theUser.organisation.id
			// this.curUserN = this.curUser.firstName
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		getLimits () {
			const url = config.serverURI + '/limit/active/' + this.organisationId
			axios.get(url)
				.then(response => {
					this.limits = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		}
	}
}

</script>
<style>
.viewlimits_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.viewlimits_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}
.table  tbody  tr >  td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733D29;
}

.pagination>li>a,
.pagination>li>span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}
.pagination>li.active>.page-link {
  background: #00513B;
  color: #fff;
}
</style>
